'use client';

import {useFetchProfile} from '@rocket-ui/lk-api';
import Script from 'next/script';
import {SCREEN_SIZE, useMediaQuery, useScrollLock} from '@rocket-ui/react-tools';
import {useEffect, useState} from 'react';

export const HelpDesk: React.FC = () => {
	//const isTokenSet = useAtomValue(tokenIsSetAtom);
	const {data, isFetched} = useFetchProfile();
	const isMobile = useMediaQuery(`(max-width: ${SCREEN_SIZE.SM})`);
	const [isWidgetOpen, setIsWidgetOpen] = useState(false);

	useEffect(() => {
		if (!isFetched || !isMobile) {
			return;
		}

		const checkWidgetState = () => {
			const container = document.getElementById('hde-container');
			const isOpen = container && window.getComputedStyle(container).display !== 'none';
			setIsWidgetOpen(Boolean(isOpen));
		};

		checkWidgetState();

		const observer = new MutationObserver(checkWidgetState);
		observer.observe(document.body, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['style', 'class'],
		});

		return () => {
			observer.disconnect();
		};
	}, [isFetched, isMobile]);

	useScrollLock(isMobile && isWidgetOpen);

	if (!isFetched) {
		return null;
	}

	return (
		<>
			<style>{`
				#hde-contact-container {
					position: fixed !important;
					right: 20px !important;
					bottom: 20px !important;
					margin: 0 !important;
					z-index: 20;
				}
			`}</style>
			<Script
				src="//cdn5.helpdeskeddy.com//js/contact-widget.js"
				defer
				id="hde-contact-widget"
				data-assets-host="//cdn5.helpdeskeddy.com/"
				data-host="vtorium.helpdeskeddy.com"
				data-lang="ru"
				data-user-name={data?.info?.firstName}
				data-user-email={data?.info?.email}
				data-comment={
					data?.info
						? `Источник: ЛК Рокет Ворк
						ИНН: ${data.info.inn}
						email: ${data.info.email}
						ФИО: ${data.info.secondName} ${data.info.firstName} ${data.info.patronymic}
						Номер телефона: ${data.info.phone}`
						: undefined
				}
			/>
		</>
	);
};
